import Name from './Name';
import Email from './Email';
import Phone from './Phone';
import User from './User';
import DeputyUser from './DeputyUser';
import Category from './Category';
import Location from './Location';
import Partner from './Partner';
import ShopChain from './ShopChain';
import Created from './Created';
import Updated from './Updated';
import Id from './Id';
import Status from './Status';
import Country from './Country';
import County from './County';
import Address from './Address';
import PostalCode from './PostalCode';
import City from './City';

export const labels = {
  Id: 'Id',
  Name: 'Név',
  Email: 'E-mail',
  Phone: 'Telefon',
  User: 'Területi képviselő',
  DeputyUser: 'Területi képviselő helyettes',
  Category: 'Kategória',
  Status: 'Státusz',
  Location: 'Terület',
  Partner: 'Partner',
  ShopChain: 'Üzletlánc',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  Country: 'Ország',
  County: 'Megye',
  PostalCode: 'Irányítószám',
  City: 'Város',
  Address: 'Cím',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Email',
}, {
  value: 'Phone',
}, {
  value: 'User',
}, {
  value: 'DeputyUser',
}, {
  value: 'Category',
}, {
  value: 'Status'
}, {
  value: 'Address',
}, {
  value: 'Location',
}, {
  value: 'ShopChain',
}, {
  value: 'Partner',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Country'
}, {
  value: 'County'
}, {
  value: 'PostalCode'
}, {
  value: 'City'
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Name',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'User',
}, {
  value: 'Address',
}, {
  value: 'Partner'
}];

export const defaultSort = {
  prop: Name.propName,
  order: 'ascending'
};

export default {
  Name,
  Email,
  Phone,
  Category,
  Partner,
  Address,
  ShopChain,
  Location,
  Updated,
  Created,
  Id,
  Status,
  User,
  DeputyUser,
  Country,
  County,
  PostalCode,
  City
};
